import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../../redux";
import { Entity, Person, GRAPHQL_TYPE_PERSON } from "@radivision/graphql";
import { isOwner } from "../../../../utilities/is-owner";
import { ProfilePicture } from "../../../page-framework/profile-picture-name/profile-picture";
import { getProfileInfo } from "../../../../utilities/get-profile-info";
import { Router } from "../../../../utilities/router";
import { DeleteCompanyButton } from "./delete-company-button";

interface ComponentProps {
  subject: Person | Entity;
}

interface MapDispatchProps {}

interface MapStateProps {
  user: Person | null;
}

export type Props = ComponentProps & MapDispatchProps & MapStateProps;

export const FoundedCompaniesComponent = (props: Props) => {
  const { subject, user } = props;
  const goTo = React.useCallback(
    (profileUrl) => (e) => {
      e.preventDefault();
      Router.navigateTo(profileUrl);
    },
    [],
  );
  if (!subject || subject?.__typename !== GRAPHQL_TYPE_PERSON) return null;
  const owner = isOwner(subject, user);
  const person = subject as Person;
  const hasCompanies = person?.entities?.length ? true : false;
  if (!hasCompanies) return null;
  return (
    <Container>
      <div className="section-header">
        <h3 className="section-title">{owner ? "My" : ""} Founded Companies</h3>
      </div>
      {person?.entities?.map((entity) => {
        const { profileUrl } = getProfileInfo(entity);
        return (
          <div className="company-card" key={`entity-${entity.id}`}>
            <div className="company-logo">
              {owner && <DeleteCompanyButton entity={entity} collection="entities"/>}
              <ProfilePicture subject={entity} numberOfItems={2} />
            </div>
            <div className="company-text">
              <h3 className="company-name">
                <a href={profileUrl} onClick={goTo(profileUrl)}>
                  {entity?.name}
                </a>
              </h3>
              <div className="company-tagline">{entity?.tagLine}</div>
            </div>
          </div>
        );
      })}
    </Container>
  );
};

const Container = ({ children }: React.PropsWithChildren<any>) => <div className="founded-companies">{children}</div>;
const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = {};

export const FoundedCompanies = connect(mapState, mapDispatch)(FoundedCompaniesComponent);
